import { Spin } from 'antd';

function Loader() {
  return (
    <Spin
      size='large'
      fullscreen
    />
  );
}

export default Loader;
